import { render } from "./EditDependencyField.vue?vue&type=template&id=cee2626e"
import script from "./EditDependencyField.vue?vue&type=script&lang=js"
export * from "./EditDependencyField.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__